import { Libraries } from '@react-google-maps/api'

export const GOOGLE_MAPS_CONFIG = {
  id: "google-map-script",
  libraries: ['places', 'geometry'] as Libraries,
  googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ""
}